/* ============================================================
   ATELIER COLOURS - /pages/colours "Find your finish"
   Behavior port of _bsd-atelier-colours-merged-harness.html (v4).
   All finish data lives on the swatch <a> data-attrs (rendered
   server-side by sections/atelier-colours.liquid) - no duplicate
   data store here. Harness-only toast/note-strip dropped: on the
   real site the swatch IS the link and just navigates.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('.at-colours');
  if (!root) return;

  var grid = root.querySelector('#coSwGrid');
  var wash = root.querySelector('#coWash');
  var fTone = root.querySelector('#coTone');
  var fName = root.querySelector('#coName');
  var fChar = root.querySelector('#coChar');
  var fBlurb = root.querySelector('#coBlurb');
  var fCap = root.querySelector('#coCap');
  var count = root.querySelector('#coCount');
  var front = root.querySelector('#coFeatA'); /* visible buffer */
  var back = root.querySelector('#coFeatB');

  var sws = Array.prototype.slice.call(grid.querySelectorAll('.co-sw'));
  var TONE_LABEL = { warm: 'Warm', cool: 'Cool', neutral: 'Neutral' };
  var TONE_DOT = { warm: '#cda35a', cool: '#9fc2cf', neutral: '#cfd0d2' };

  function hexA(hex, a) {
    var h = hex.replace('#', '');
    return 'rgba(' + parseInt(h.slice(0, 2), 16) + ',' + parseInt(h.slice(2, 4), 16) + ',' + parseInt(h.slice(4, 6), 16) + ',' + a + ')';
  }
  function byKey(k) {
    for (var i = 0; i < sws.length; i++) if (sws[i].dataset.key === k) return sws[i];
    return null;
  }

  var selectedKey = 'brushed-gold';

  /* ---------- specimen fan: real product shots in the active finish ---------- */
  var fan = root.querySelector('#coFan');
  var fanData = {};
  try { fanData = JSON.parse(root.querySelector('#coFanData').textContent); } catch (e) {}
  var fanCards = fan ? Array.prototype.slice.call(fan.querySelectorAll('.co-card')) : [];
  /* SETTLE pattern: rapid hover-sweeps across the grid must NOT restart the deal
     animation per swatch (mid-flight restarts strand the cards half-risen with
     half-swapped images). During a sweep the fan keeps the PREVIOUS finish fully
     landed; only when the pointer settles on a finish (160ms) does it re-deal
     once. Settling back on the finish already shown re-deals nothing. */
  var fanT, lastFanKey = null;
  function applyFan(key) {
    if (!fan || key === lastFanKey) return;
    lastFanKey = key;
    var imgs = fanData[key] || [];
    fan.classList.toggle('empty', !imgs.length);
    fanCards.forEach(function (card, i) {
      var img = card.querySelector('img');
      if (imgs[i]) {
        card.hidden = false;
        /* load-fade: a not-yet-cached image stays invisible (white card) until it
           arrives, instead of painting half-swapped */
        img.style.opacity = '0';
        img.onload = function () { img.style.opacity = ''; };
        img.src = imgs[i];
        if (img.complete) img.style.opacity = '';
      } else {
        card.hidden = true;
        img.removeAttribute('src');
      }
    });
    fan.classList.remove('deal');
    void fan.offsetWidth;
    fan.classList.add('deal');
  }
  function setFan(key) {
    clearTimeout(fanT);
    fanT = setTimeout(function () { applyFan(key); }, 160);
  }
  /* warm the cache once the page has settled so finish switching swaps instantly */
  setTimeout(function () {
    Object.keys(fanData).forEach(function (k) {
      (fanData[k] || []).forEach(function (u) { new Image().src = u; });
    });
  }, 1200);

  /* paint the feature (visual only) - used by both selection and hover-preview */
  function paintFeature(el) {
    var d = el.dataset;
    /* disc crossfade - paint back buffer, fade in, swap (.co-shine child survives
       the className write; children are untouched) */
    back.className = 'co-fm co-m co-m--' + d.g;
    void back.offsetWidth;
    back.classList.add('on');
    front.classList.remove('on');
    var tmp = front; front = back; back = tmp;
    /* wash tinted in the finish's own colour */
    wash.style.background = 'radial-gradient(120% 100% at 50% 16%, ' + hexA(d.base, 0.42) + ', ' + hexA(d.base, 0.1) + ' 55%, #12110f 82%)';
    /* text */
    fTone.querySelector('span').textContent = TONE_LABEL[d.tone];
    fTone.querySelector('i').style.background = TONE_DOT[d.tone];
    fName.textContent = d.name;
    fChar.textContent = d.char;
    fBlurb.textContent = d.blurb;
    setFan(d.key);
    /* re-reveal the caption so the text rises in rather than snapping */
    fCap.classList.remove('reveal');
    void fCap.offsetWidth;
    fCap.classList.add('reveal');
  }
  function selectFinish(el) {
    if (!el) return;
    selectedKey = el.dataset.key;
    sws.forEach(function (s) { s.classList.toggle('on', s === el); });
    paintFeature(el);
  }

  /* interactions - the SWATCH IS THE LINK (one click/tap navigates to its
     collection). Desktop bonus: hovering a swatch previews it in the pane and
     KEEPS it there (no snapping back). Debounced so a fast sweep across the
     grid doesn't thrash the crossfade. */
  var hoverT;
  sws.forEach(function (s) {
    s.addEventListener('mouseenter', function () {
      if (!matchMedia('(hover: hover)').matches) return;
      clearTimeout(hoverT);
      hoverT = setTimeout(function () { selectFinish(s); }, 55);
    });
  });
  grid.addEventListener('click', function (e) {
    var a = e.target.closest('.co-sw');
    if (!a) return;
    selectFinish(a); /* instant feedback while the navigation starts */
  });

  /* NOTE: the harness's auto-cycle (interval stepping through the metals until
     first interaction) is REMOVED - the repeated repaints lagged the page and
     janked the header morph on mobile. The stage starts on brushed-gold and
     moves on hover/tap only. */

  /* initial deal-in for the default finish (server renders the stage text;
     the fan is JS-populated from the JSON map) - immediate, no settle delay */
  applyFan(selectedKey);

  /* ---------- hero metal word: "finish" cast in live metal, cycling ----------
     Two stacked copies of the word cross-fade between finish ramps every few
     seconds (cycle list rendered server-side on data-cycle; whites excluded -
     invisible on the cream bg). Perf story vs the REMOVED stage auto-cycle
     above: the paint area is one word, not a 262px blended stage; the fade is
     opacity-only (composited); the sweep is killed <=991 with the other
     live-metal layers; and the cycle pauses off-screen + under reduced motion. */
  var hm = root.querySelector('#coHm');
  if (hm && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var hmLayers = hm.querySelectorAll('.co-hm__t');
    var hmFront = hmLayers[0], hmBack = hmLayers[1];
    var hmKeys = (hm.dataset.cycle || '').split(' ').filter(Boolean);
    var hmI = 0, hmSeen = true;
    var hmIo = new IntersectionObserver(function (es) {
      es.forEach(function (en) { hmSeen = en.isIntersecting; });
    }, { threshold: 0 });
    hmIo.observe(hm);
    if (hmKeys.length > 1) setInterval(function () {
      if (!hmSeen) return;
      hmI = (hmI + 1) % hmKeys.length;
      hmBack.className = 'co-hm__t co-hm--' + hmKeys[hmI] + ' on';
      hmFront.classList.remove('on');
      var hmT = hmFront; hmFront = hmBack; hmBack = hmT;
    }, 3600);
  }

  /* ---------- FILTER: tone segments, animated via FLIP ----------
     Non-matching swatches hide instantly, the remaining ones GLIDE to their
     new grid positions (First-Last-Invert-Play), newly-matching ones fade in. */
  var segs = root.querySelector('#coSegs');
  function selectTone(f) {
    segs.querySelectorAll('.co-seg').forEach(function (x) { x.classList.toggle('on', x.dataset.f === f); });
    runFilter(f);
  }
  segs.addEventListener('click', function (e) {
    var b = e.target.closest('.co-seg');
    if (!b) return;
    selectTone(b.dataset.f);
  });

  /* NOTE: the temperature cards are plain LINKS to pre-filtered tapware
     collections (built in the liquid) - they no longer mirror the segs filter. */

  function runFilter(f) {
    /* FIRST: live positions of currently-visible swatches (captures any in-flight
       glide, so rapid clicks stay continuous) */
    var first = new Map();
    sws.forEach(function (el) { if (!el.classList.contains('gone')) first.set(el, el.getBoundingClientRect()); });

    var shown = 0;
    var moving = []; /* everything visible AFTER this filter (stayers + newcomers) */
    sws.forEach(function (el) {
      var ok = (f === 'all' || el.dataset.tone === f);
      if (ok) { shown++; el.classList.remove('gone'); moving.push(el); }
      else { el.classList.add('gone'); }
    });
    if (count) count.textContent = shown + (shown === 1 ? ' finish' : ' finishes');

    /* the feature pane must show a finish that's actually in this filter */
    var stillIn = moving.some(function (el) { return el.dataset.key === selectedKey; });
    if (moving.length && !stillIn) selectFinish(moving[0]);

    /* reset so LAST is measured at natural grid positions */
    moving.forEach(function (el) { el.style.transition = 'none'; el.style.transform = ''; el.style.opacity = ''; });

    /* INVERT: stayers get offset back to where they were; newcomers start small+clear */
    moving.forEach(function (el) {
      var f0 = first.get(el);
      var l = el.getBoundingClientRect();
      if (f0) {
        el.style.transform = 'translate(' + (f0.left - l.left) + 'px,' + (f0.top - l.top) + 'px)';
      } else {
        el.style.transform = 'scale(.78)';
        el.style.opacity = '0';
      }
    });

    /* PLAY next frame - glide to place / fade in */
    requestAnimationFrame(function () {
      moving.forEach(function (el) {
        el.style.transition = 'transform .5s cubic-bezier(.2,.7,.2,1), opacity .42s ease';
        el.style.transform = '';
        el.style.opacity = '';
      });
    });
  }

  /* ---------- SCROLL REVEAL ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12 });
  root.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });

  /* editorial drift bands only animate while their card is on screen
     (blur + blend on an infinite loop is not free - keep it off off-screen) */
  var driftIo = new IntersectionObserver(function (es) {
    es.forEach(function (en) { en.target.classList.toggle('play', en.isIntersecting); });
  }, { threshold: 0.05 });
  root.querySelectorAll('.co-ed-card').forEach(function (el) { driftIo.observe(el); });
})();
